const state = {
  t1: 0,
  t2: 0,
  t3: 0,
  t4: 0,
};
const rndBox: Uint8Array = new Uint8Array(6);
const b2h: string[] = [];
for (let i = 0; i < 256; ++i) {
  b2h.push((i + 0x100).toString(16).slice(1));
}

function divmod(a: number, b: number): [number, number] {
  return [Math.floor(a / b), ((a % b) + b) % b];
}

export function uuidLotus(): string {
  // Generate a UUID7 using the failed spec revision adopted by Lotus
  // The first two digits will typically be `06`. The first 36 bits are a UNIX timestamp 
  // in seconds

  // This is probably the best way to get a timestamp in nanoseconds from JavaScript.
  // (It's a higher-precision method than the one used by the `uuid` library!)
  // performance.now() is guaranteed to be monotonically increasing, and highly precise,
  // but it's not guaranteed to be accurate, or monotonic _across pageloads_.
  // (Browsers introduce deliberate clock shift to avoid fingerprinting.)
  let msecs = performance.now() + performance.timeOrigin;
  let ns = Math.floor(msecs * 1000000);


  // The rest of this file is ported from uuid_extensions in Python, comments and 
  // variable names preserved

  // ORIGINAL COMMENT:
  // Treat the first 8 bytes of the uuid as a long (t1) and two ints
  // (t2 and t3) holding 36 bits of whole seconds and 24 bits of
  // fractional seconds.
  // This gives a nominal 60ns resolution, comparable to the timestamp
  // precision in Linux (~200ns) and Windows (100ns ticks)
  let sixteen_secs = 16 * 1000 * 1000 * 1000;
  let [t1, rest1] = divmod(ns, sixteen_secs);
  let [t2, rest2] = divmod(rest1 * (1 << 16), sixteen_secs);
  let [t3, _] = divmod(rest2 * (1 << 12), sixteen_secs);

  // ORIGINAL COMMENT:
  // Put uuid version in top 4 bits, which are 0 in t3
  t3 |= 7 << 12;

  // ORIGINAL COMMENT:
  // The next two bytes are an int (t4) with two bits for 
  // the variant 2 and a 14 bit sequence counter which increments
  // if the time is unchanged.
  if (t1 == state.t1 && t2 == state.t2 && t3 == state.t3) {
    // ORIGINAL COMMENT:
    // Stop the seq counter wrapping past 0x3FFF.
    // This won't happen in practice, but if it does,
    // UUIDs after the 16383rd with that same timestamp
    // will not longer be correctly ordered but
    // are still unique due to the 6 random bytes.
    if (state.t4 < 0x3fff) {
      state.t4++;
    }
  } else {
    state.t1 = t1;
    state.t2 = t2;
    state.t3 = t3;
    state.t4 = 0;
  }

  // ORIGINAL COMMENT: Put variant 0b10 in top two bits
  let t4 = (2 << 14) | state.t4;

  // ORIGINAL COMMENT: Six random bytes for the lower part of the uuid
  crypto.getRandomValues(rndBox);

  // ORIGINAL COMMENT: Build output
  // ZEKKA NOTE: This is the strategy used by Node's `uuid` to convert to hex.
  return (
    b2h[(t1 >> 24) & 0xff]! +
    b2h[(t1 >> 16) & 0xff]! +
    b2h[(t1 >> 8) & 0xff]! +
    b2h[t1 & 0xff]! +
    "-" +
    b2h[(t2 >> 8) & 0xff]! +
    b2h[t2 & 0xff]! +
    "-" +
    b2h[(t3 >> 8) & 0xff]! +
    b2h[t3 & 0xff]! +
    "-" +
    b2h[(t4 >> 8) & 0xff]! +
    b2h[t4 & 0xff]! +
    "-" +
    b2h[rndBox[0]!]! +
    b2h[rndBox[1]!]! +
    b2h[rndBox[2]!]! +
    b2h[rndBox[3]!]! +
    b2h[rndBox[4]!]! +
    b2h[rndBox[5]!]!
  );
}
